


















































































import Brand from '@/types/Brand.interface'
import Vue from 'vue'
export default Vue.extend({
    props: {
        articleLink: {
            type: String,
            default:
                'https://learn.messagedesk.com/en/articles/6365302-why-and-how-to-register-your-traffic-to-avoid-failures'
        }
    },
    data() {
        return {
            // Tri-Panel toolbar
            toolbar: {
                title: 'Carrier Registration',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        tooltip: 'Back',
                        permission: 0,
                        feature: null
                    }
                ],
                right: []
            }
        }
    },
    computed: {
        brand(): Brand {
            return this.$store.getters.brand
        },
        isApp(): boolean {
            return this.$store.getters.isApp
        },
        registered(): boolean {
            //  Grab our A2P settings
            const setting = this.$store.getters.settingGet('a2pEnabled')

            //  Condition depends on existence
            return setting ? true : false
        },
        unregistered(): boolean {
            return !this.brand || window._.isEmpty(this.brand)
        }
    },
    methods: {
        goToArticle(): void {
            window.open(this.articleLink, this.isApp ? '_system' : '_blank')
        },
        popIntercomMessenger(): void {
            // Close help modal component
            this.$store.commit('helpModalSet', false)

            //  @ts-ignore If we are on the mobile app, then call our Cordova plugin
            if (this.isApp) intercom.displayMessenger()
            // Pops the intercom messenger through the id bound to the hidden span element
            else window.popSupportMessenger()
        },
        popRegisterHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Info',
                text: `Registering with the carriers allows for us to verify that you are sending messages for legitimate purposes. This prevents your messages from being blocked when they shouldn't be.\n<br>This business information is not to be used for any purpose other than registration. To find out more about registration, <a href='${this.articleLink}' target=\"_blank\" style=\"text-decoration: none;\">visit this article.</a>`,
                icon: 'mdi-help-circle',
                color: 'primary darken-2'
            })
        }
    }
})
